<template>
  <div>
    <a href="#" :class="cellClass">
      <div class="kbo-landscape-cell-box">
        <ul class="kbo-info-team">
          <li>
              <span class="team-name">
                <span class="team-name-img">
                  <img :src="awayTeamImage" :alt="awayTeamName">
                </span>
                <span class="team-name-txt">{{awayTeamName}}</span>
              </span>
            <span class="team-pitcher">{{awayTeamPitcherOrScore}}</span>
          </li>
          <li>
              <span class="team-name">
                <span class="team-name-img">
                  <img :src="homeTeamImage" :alt="homeTeamName">
                </span>
                <span class="team-name-txt">{{homeTeamName}}</span>
              </span>
            <span class="team-pitcher">{{homeTeamPitcherOrScore}}</span>
          </li>
        </ul>
      </div>
      <div class="kbo-landscape-cell-box">
        <div class="kbo-info-time">
          <span>{{gameDate}}</span>
          <span>{{gameTimeAndPlace}}</span>
        </div>
        <baseball-alarm v-if="hasAlarmBtn" :alarm-yn="alarmYN"></baseball-alarm>
      </div>
    </a>
  </div>
</template>

<script>
  import _ from 'lodash'
  import BaseballAlarm from '@/components/kbo/BaseballAlarm'
  export default {
    name: 'BaseballLandscapeCell',
    components: {
      BaseballAlarm
    },
    props: {
      cellInfo: {
        type: Object
      },
      baseballScheduleCount: {
        type: Number
      },
      cellList: {
        type: Array
      }
    },
    computed: {
      homeTeamName () {
        return this.teamName(_.get(this.cellInfo, 'home_team', ''))
      },
      homeTeamImage () {
        // TODO: default 이미지 뭘로 할건지 기획에서 확인후 default 이미지 설정
        return this.teamImage(_.get(this.cellInfo, 'home_team', ''))
      },
      awayTeamName () {
        return this.teamName(_.get(this.cellInfo, 'away_team', ''))
      },
      awayTeamImage () {
        // TODO: default 이미지 뭘로 할건지 기획에서 확인후 default 이미지 설정
        return this.teamImage(_.get(this.cellInfo, 'away_team', ''))
      },
      gameDate () {
        return _.get(this.cellInfo, 'title_list.0.text', '')
      },
      gameTimeAndPlace () {
        return _.get(this.cellInfo, 'title_list.1.text', '')
      },
      alarmOn () {
        return _.get(this.cellInfo, 'alarm_on', 'N').toUpperCase()
      },
      alarmYN () {
        return _.get(this.cellInfo, 'alarm_yn', 'N').toUpperCase()
      },
      gameStatus () {
        return _.get(this.cellInfo, 'game_status', 'PREV').toUpperCase()
      },
      hasAlarmBtn () {
        return _.get(this.cellInfo, 'svc_id', '') !== '' &&
          this.alarmOn !== 'N' &&
          this.gameStatus !== 'LIVE'
      },
      homeTeamPitcherOrScore () {
        if (this.gameStatus === 'END' || this.gameStatus === 'LIVE') {
          return this.score(_.get(this.cellInfo, 'home_team', {}))
        } else {
          return this.pitcher(_.get(this.cellInfo, 'home_team', {}))
        }
      },
      awayTeamPitcherOrScore () {
        if (this.gameStatus === 'END' || this.gameStatus === 'LIVE') {
          return this.score(_.get(this.cellInfo, 'away_team', {}))
        } else {
          return this.pitcher(_.get(this.cellInfo, 'away_team', {}))
        }
      },
      cellClass () {
        if (this.gameStatus === 'PREV' && this.serviceId !== '') {
          return 'kbo-landscape-cell kbo-cell-alarm'
        } else {
          return 'kbo-landscape-cell'
        }
      }
    },
    methods: {
      pitcher (team) {
        return _.get(team, 'team_pitcher', '미정')
      },
      score (team) {
        return _.get(team, 'team_score', 0)
      },
      teamName (team) {
        return _.get(team, 'team_name', '')
      },
      teamImage (team) {
        return _.get(team, 'team_image', '')
      }
    }
  }
</script>
